import { ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IDisplayClassGroup {
  dNone: ViewStyle;
  dInlineFlex: React.CSSProperties;
  dFlex: ViewStyle;
  zIndex10000: ViewStyle;
}
export const DisplayClassGroup: ClassGroupType<IDisplayClassGroup> = {
  dNone: { display: "none" },
  dInlineFlex: { display: "flex" },
  dFlex: { display: "flex" },
  zIndex10000: { zIndex: 10000 },
};
